import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FiMenu, FiX } from 'react-icons/fi';
import './Navbar.css';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <div className="navbar-logo">
          <Link to="/" className="logo">
            StoryCape
          </Link>
        </div>

        {/* Desktop Navigation */}
        <div className="nav-menu desktop">
          <a href="#features" className="nav-link">Features</a>
          <a href="#how-it-works" className="nav-link">How It Works</a>
          <a href="#pricing" className="nav-link">Pricing</a>
          <a href="#contact" className="nav-button">Contact Us</a>
          <a href="https://console.storycape.io" className="nav-button console-button" target="_blank" rel="noopener noreferrer">CONSOLE</a>
        </div>

        {/* Mobile Navigation Button */}
        <div className="mobile-menu-icon">
          <button onClick={() => setIsOpen(!isOpen)} className="menu-button">
            {isOpen ? <FiX size={24} /> : <FiMenu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Navigation Menu */}
      {isOpen && (
        <div className="mobile-menu">
          <a href="#features" className="mobile-link" onClick={() => setIsOpen(false)}>
            Features
          </a>
          <a href="#how-it-works" className="mobile-link" onClick={() => setIsOpen(false)}>
            How It Works
          </a>
          <a href="#pricing" className="mobile-link" onClick={() => setIsOpen(false)}>
            Pricing
          </a>
          <a href="https://console.storycape.io" className="mobile-button console-button" target="_blank" rel="noopener noreferrer" onClick={() => setIsOpen(false)}>
            CONSOLE
          </a>
          <a href="#contact" className="mobile-button" onClick={() => setIsOpen(false)}>
            Contact Us
          </a>
        </div>
      )}
    </nav>
  );
};

export default Navbar;